import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { EnvelopeFilter } from './envelope-filter';

export class SentEnvelopeFilter extends EnvelopeFilter {
    status: SentEnvelopeStatus;
}
